module.exports = __webpack_public_path__ + "img/IMG_8906_2.578a882b.png";